module.exports = __webpack_public_path__ + "img/paypal-logo-svg-vector.b1807e33.svg";